export default __webpack_public_path__ + "static/media/banner-placeholder.6b3ed9b5.png";